export function InitEditSettlementPage() {
    const $datasForEditSettlementPage: JQuery<HTMLElement> = $('#edit-settlement-datas');

    if (!$datasForEditSettlementPage || $datasForEditSettlementPage.length == 0) {
        return;
    }

    setIsExtractFieldEvent();

    setTypeField();

    setSettlementFields();

    setCountryNameField();

    function getIsExtractField(): JQuery<HTMLElement> {
        const isExtractFieldId: string = $datasForEditSettlementPage.data('is-extract-field-id');
        return $('#' + isExtractFieldId);
    }

    function getTypeFieldId(): string {
        return $datasForEditSettlementPage.data('type-field-id');
    }

    function getTypeField(): JQuery<HTMLElement> {
        const typeFieldId: string = getTypeFieldId();
        return $('#' + typeFieldId);
    }

    function rarefyTypeSelectList() {
        getTypeField().empty();

        getTypeField().append($('<option>', {
            value: 'SubjectEstate',
            text: 'Tárgyi ingatlan'
        }));
    }

    function setIsExtractFieldEvent() {
        let $isExtractField: JQuery<HTMLElement> = getIsExtractField();

        onIsExtractCbValueChanged($isExtractField);

        $isExtractField.off('change').on('change', (event: JQuery.ChangeEvent) => {
            onIsExtractCbValueChanged($(event.currentTarget));
        });
    }

    function onIsExtractCbValueChanged($isExtractCb: JQuery<HTMLElement>) {
        let $typeField: JQuery<HTMLElement> = getTypeField();

        if ($isExtractCb.is(':checked')) {
            rarefyTypeSelectList();

        } else {
            regenerateTypeSelectList();
        }

        function regenerateTypeSelectList() {
            const template: JQuery<HTMLTemplateElement> = $('#type-dropdown-template');
            const clone: JQuery<HTMLTemplateElement> = template.clone(true, true);

            $typeField.replaceWith(clone.prop('content'));
        }
    }

    function setSettlementFields() {
        const settlementIdFieldId: string = $datasForEditSettlementPage.data('settlement-id-field-id');
        let $settlementIdField: JQuery<HTMLElement> = $('#' + settlementIdFieldId);
        const settlementNameFieldId: string = $datasForEditSettlementPage.data('settlement-name-field-id');
        let $settlementNameField: JQuery<HTMLElement> = $('#' + settlementNameFieldId);

        if (settlementIdFieldNotExists()) {
            $settlementIdField.val($('#DefaultTownId').val());
            $settlementNameField.val($('#DefaultTownNev').val());
        }

        function settlementIdFieldNotExists() {
            return !$settlementIdField;
        }
    }

    function setTypeField() {
        const $isExtractField: JQuery<HTMLElement> = getIsExtractField();

        if ($isExtractField && $isExtractField.is(':checked')) {
            rarefyTypeSelectList();
        }
    }

    function setCountryNameField() {
        const countryNameFieldId: string = $datasForEditSettlementPage.data('country-name-field-id');
        let $countryName: JQuery<HTMLElement> = $('#' + countryNameFieldId);

        $countryName.attr('readonly', 'readonly');

        // Ayy firefox, why can't you handle the TAB event correctly
        $countryName.attr('tabindex', '-1');
    }
}
